import {resolvePartnerHostInfo} from './partner-host'

type ResolvePartnerSlugOptions = {
    allowEnvFallback?: boolean
}

export function resolvePartnerSlug(host?: string | null, options: ResolvePartnerSlugOptions = {}): string | null {
    const {allowEnvFallback = true} = options
    const hostSlug = resolvePartnerHostInfo(host ?? (typeof window !== 'undefined' ? window.location.host : null)).slug
    if (hostSlug) return hostSlug
    if (!allowEnvFallback) return null
    const env = process.env.NEXT_PUBLIC_PARTNER_SLUG?.trim()
    if (env) return env
    return null
}

export function resolvePartnerSlugOrLocal(host?: string | null): string {
    return resolvePartnerSlug(host) ?? 'local'
}
